import { render } from "./ColorSelectInput.vue?vue&type=template&id=eddf57c0&scoped=true"
import script from "./ColorSelectInput.vue?vue&type=script&lang=js"
export * from "./ColorSelectInput.vue?vue&type=script&lang=js"

import "./ColorSelectInput.vue?vue&type=style&index=0&id=eddf57c0&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eddf57c0"]])

export default __exports__